import { render, staticRenderFns } from "./PayCard.vue?vue&type=template&id=5e2f31c9&scoped=true&"
import script from "./PayCard.vue?vue&type=script&lang=js&"
export * from "./PayCard.vue?vue&type=script&lang=js&"
import style0 from "./PayCard.vue?vue&type=style&index=0&id=5e2f31c9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f31c9",
  null
  
)

export default component.exports